import { AppContainer } from "../../components";
import { useNavigate } from "react-router-dom";
import { IoCalendarOutline } from "react-icons/io5";
import { PiSoccerBallFill } from "react-icons/pi";
import { FaChartBar } from "react-icons/fa";

export const Stats = () => {
  const navigation = useNavigate();
  return (
    <>
      <AppContainer>
        <div className='flex h-full flex-col items-center w-[100%] z-20'>
          <p className='text-xl text-white font-bold text-center w-[50vw] mt-5'>
            Stats
          </p>
          <div className='gap-[38px] grid grid-cols-3 mt-[5rem]'>
            <div
              className='funtionality'
              onClick={() => navigation("/stats/over05HT")}>
              <div className='img-container'>
                <PiSoccerBallFill size={24} />
              </div>
              <div className='text-[11px] text-center leading-[11px] font-semibold'>
                <label>Over 0.5 HT</label>
              </div>
            </div>
            <div
              className='funtionality'
              onClick={() => navigation("/stats/over05HTOdds")}>
              <div className='img-container'>
                <FaChartBar size={24} />
              </div>
              <div className='text-[11px] text-center leading-[11px] font-semibold'>
                <label>Over 0.5 HT odds</label>
              </div>
            </div>
           
          </div>
        </div>
      </AppContainer>
    </>
  );
};
